export const useGtm = () => {
  //* Google tag manager tracking
  const pushGtm = (targetElement: HTMLElement | any) => {
    const valueAttribute = targetElement?.attributes?.['glasson-click']?.value
    const dataLayer = (window as AnyObject).dataLayer

    if (!valueAttribute) {
      console.warn('Not found element')
      return
    }
    if (!dataLayer) {
      console.warn('Not found GTM dataLayer')
      return
    }

    // * Get value
    const config = {
      event: 'glasson-click',
      custom_event: {
        value: valueAttribute,
        element: targetElement,
        elementId: targetElement.id || '',
        elementClasses: targetElement.className || '',
        elementUrl: targetElement?.href || targetElement?.action || '',
        elementTarget: targetElement?.target || '',
        originalEvent: 'click',
        inShadowDom: true,
      },
    }
    // TODO: Push if exist
    dataLayer.push(config)
  }

  //* Meta Pixel Facebook tracking
  const pushPixel = (targetElement: HTMLElement | any) => {
    const valueAttribute = targetElement?.attributes?.['glasson-click']?.value
    const fbq = (window as AnyObject).fbq

    if (!fbq) {
      console.warn('Not found Meta Pixel fbq')
      return
    }

    fbq('trackCustom', valueAttribute)
  }

  return {
    pushGtm,
    pushPixel,
  }
}
